
import { mapActions, mapMutations, mapGetters } from 'vuex';
import CallIcon from '@/components/svg/mobile/CallIcon';
import CatalogIcon from '@/components/svg/mobile/CatalogIcon';
import CartIcon from '@/components/svg/CartIcon';
import ChatIcon from '@/components/svg/mobile/ChatIcon';
import CompareIcon from '@/components/svg/CompareIcon.vue';
import FavoritesClearIcon from '@/components/svg/FavoritesClearIcon';
import ProfileFilledIcon from '@/components/svg/ProfileFilledIcon';
import ProfileEmptyIcon from '@/components/svg/ProfileEmptyIcon';
import SearchFormEcom from '@/components/header/SearchFormEcom.vue';
import vClickOutside from 'v-click-outside';
import header from '~/mixins/header';
export default {
    components: {
        SearchFormEcom,
        ChatIcon,
        CartIcon,
        CatalogIcon,
        CallIcon,
        FavoritesClearIcon,
        CompareIcon,
        ProfileFilledIcon,
        ProfileEmptyIcon,
    },
    directives: {
        clickOutside: vClickOutside.directive,
    },
    mixins: [header],
    computed: {
        ...mapGetters({
            mainPhoneNumber: 'global/mainPhoneNumber',
            isAuth: 'auth/isAuth',
            isVitrina: 'global/isVitrina',
            isNovaPorta: 'global/getIsNovaPorta',
            favoritesProductsLength: 'favorites/getProductsLength',
            cartProductsLength: 'cart/getProductsLength',
            getShowNavigationMobile: 'getShowNavigationMobile',
            globalSettings: 'global/globalSettings',
            compareProductsLength: 'compare/getCompareProductsLength',
        }),
        isAuthentificationAllowed() {
            return this.globalSettings.additional_settings?.is_user_cabinet || false;
        },
        isCasaCart() {
            return this.globalSettings?.mainUiInterface?.cart_button_catalog_view_type === 'casadeltabaco';
        },
        isStepByStepCart() {
            return this.globalSettings?.mainUiInterface?.cart_button_catalog_view_type === 'step_by_step';
        },
    },
    methods: {
        ...mapMutations('search', ['setModalShow']),
        ...mapActions('cart', ['openCart', 'closeCart']),
        ...mapMutations(['setShowNavigationMobile']),
        ...mapMutations({
            setShowMenuMobile: 'setShowMenuMobile',
            initFavoritesProducts: 'favorites/initFavProducts',
        }),
        openCartMob() {
            if (this.isCasaCart || this.isStepByStepCart) {
                this.$router.push({ path: this.localePath('/cart') });
            } else {
                this.openCart();
                this.activeBarItem = 'cart';
            }
        },
        triggerAuthBtn() {
            if (this.isAuth) this.logout();
            else this.$store.dispatch('setShowAuth', true);
        },
        toggleMenu() {
            this.setShowNavigationMobile(!this.getShowNavigationMobile);
        },
        openSearch() {
            this.setModalShow(true);
        },
        openCatalog() {
            this.setShowMenuMobile(true);
            this.activeBarItem = 'catalog';
            this.closeCart();
        },
        openCall() {
            this.closeCart();
            this.activeBarItem = 'call';
            window.open(`tel:${this.mainPhoneNumber?.replace(/\s/g, '')}`, '_self');
        },
        externalClickSearch(event) {
            if (!['search__input', 'searchForm', 'search', 'update'].includes(event.target.id)) this.setModalShow(false);
        },
        favoritesProducts() {
            if (process.client && localStorage?.getItem('favorites')) {
                this.initFavoritesProducts(JSON.parse(localStorage?.getItem('favorites')));
            } else {
                this.initFavoritesProducts([]);
            }
        },
    },
    watch: {
        activeBarItem(newValue) {
            if (newValue) {
                setTimeout(() => {
                    this.activeBarItem = null;
                }, 500);
            }
        },
    },
    data() {
        return {
            activeBarItem: null,
            isCabinetWindowOpen: false,
        };
    },
    mounted() {
        this.favoritesProducts();
    },
};
